module.exports = __webpack_public_path__ + "static/media/Ain_ghazal_icon.c35f00bd.png";